import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { isMobile } from "./deviceUtils";
import './styles.css';

export function showEstruturasRemovidasAlert (onConfirmation?: Function, onClose?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: ['As estruturas foram removidas pois não estão disponíveis para o módulo selecionado.'],
    title: "Atenção!",
    size: isMobile() ? 'auto' : "440px",
    yesText: 'OK',
    propagateWhenConfirm: true,
    onClose: () => {
      confirmationDialog.close();
      if (onClose) onClose();
    },
    onConfirmation: () => {
      if(onConfirmation) onConfirmation();
    },
    className: 'show-estruturas-removidas-alert'
    // headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();

}